import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import communityApi from '../../api/communityApi';
import communityUrls from "../../configs/community/communityUrls";
import { BundleInterface } from '../../store/community/bundlesSlice';
import { settingEntity } from "./settingsActions";
import { SettingInterface } from "src/store/community/settingsSlice";

const PREFIX = 'community';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: communityUrls.bundlePath(value.id),
    icon_url: communityUrls.remoteUrl(value.icon_url)
  };
}

export const bundlesEntity = new schema.Entity(
  'bundles',
  {},
  {
    processStrategy
  }
);

export const bundleEntity = new schema.Entity(
  'bundle',
  {
    setting: settingEntity
  },
  {
    processStrategy
  }
);

const fetchBundlesCollection = async (url: string, params: object = {}) => {
  const response    = await communityApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      bundles: { [key: string]: BundleInterface };
    }
  >(response.data.bundles, [bundlesEntity]);

  return {
    bundles: normalized.entities?.bundles || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      setting: { [key: string]: SettingInterface };
      bundle: BundleInterface;
    }
  >(response.data.bundle, bundleEntity);
  return normalized.entities;
}

export const fetchBundles = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundles`,
  async (params: object = {}) => fetchBundlesCollection('/onesky/bundles', params)
);

export const fetchBundle = createAsyncThunk(
  `${PREFIX}_bundles/fetchBundle`,
  async (id: number | string) => {
    const response = await communityApi.get(`/onesky/bundles/${id}`);
    return normalizeInstance(response);
  }
);

export const createBundle = createAsyncThunk(
  `${PREFIX}_bundles/createBundle`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await communityApi.post(`/onesky/bundles`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateBundle = createAsyncThunk(
  `${PREFIX}_bundles/updateBundle`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await communityApi.patch(`/onesky/bundles/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyBundle = createAsyncThunk(
  `${PREFIX}_bundles/destroyBundle`,
  async (id: number) => {
    const response = await communityApi.delete(`/onesky/bundles/${id}`);
    return response.data;
  }
);
